<template>
  <div class="tgh-left-nav" :class="toglmenu">
    <ul>
        <li>
            <router-link to="/residential"><span @click="togLmenu()">RESIDENTIAL</span></router-link>
        </li>
        <li>
            <router-link to="/commercial"><span @click="togLmenu()">COMMERCIAL</span></router-link>
        </li>
        <li>
            <router-link to="/booking"><span @click="togLmenu()">BOOKING</span></router-link>
        </li>
        <li>
            <router-link to="/collaborators"><span @click="togLmenu()">COLLABORATORS</span></router-link>
        </li>
        <li>
            <router-link to="/gallery-catalogue"><span @click="togLmenu()">GALLERY CATALOGUE</span></router-link>
        </li>
        <li>
            <router-link to="/maps"><span @click="togLmenu()">KEEP IN TOUCH</span></router-link>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LaftNav',
  props: ['msg','toglmenu','sosmed'],
  methods : {
    togLmenu(){
      this.$parent.toglMenu()
    }
  }
}
</script>
